import { render } from "./customEmailCampaigns.vue?vue&type=template&id=2febcad6&ts=true"
import script from "./customEmailCampaigns.vue?vue&type=script&lang=ts"
export * from "./customEmailCampaigns.vue?vue&type=script&lang=ts"

import "./customEmailCampaigns.vue?vue&type=style&index=0&id=2febcad6&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__